import mixpanel from "mixpanel-browser";
const ALIASED_STORAGE_PREFIX = "lucien_mp_aliased:";
let mixpanelInitialized = false;
export function buildMixpanelInitConfig(options) {
    const cfg = {
        autocapture: options.autocapture ?? true,
        record_sessions_percent: options.recordSessionsPercent ?? 100,
        record_canvas: true,
        record_heatmap_data: true,
        record_mask_all_text: false,
        record_mask_text_selector: "",
    };
    if (options.cookieDomain) {
        cfg.cross_subdomain_cookie = true;
        cfg.cookie_domain = options.cookieDomain;
    }
    return cfg;
}
/**
 * Client-only. Safe to call from dashboard (Vite) or a Next.js client component.
 * No-ops without a token or outside the browser. Idempotent per page load.
 */
export function initMixpanelBrowser({ token, debug = false, cookieDomain, recordSessionsPercent = 100, autocapture = true, }) {
    if (typeof window === "undefined")
        return;
    if (!token)
        return;
    if (mixpanelInitialized)
        return;
    mixpanel.init(token, {
        ...buildMixpanelInitConfig({ cookieDomain, recordSessionsPercent, autocapture }),
        debug,
    });
    mixpanelInitialized = true;
}
export function isMixpanelInitialized() {
    return mixpanelInitialized;
}
export function trackMixpanelEvent(event, properties) {
    if (typeof window === "undefined")
        return;
    if (!mixpanelInitialized)
        return;
    try {
        mixpanel.track(event, properties ?? {});
    }
    catch (e) {
        console.warn("[analytics] Mixpanel track failed", event, e);
    }
}
/**
 * Links the anonymous distinct_id to the authenticated id once per device/user (localStorage),
 * then identify + people profile. Call after /api/me (or equivalent) succeeds.
 */
export function registerMixpanelUser({ distinctId, email, properties, }) {
    if (typeof window === "undefined")
        return;
    if (!mixpanelInitialized)
        return;
    const current = mixpanel.get_distinct_id();
    const aliasedKey = `${ALIASED_STORAGE_PREFIX}${distinctId}`;
    try {
        if (current !== distinctId && !localStorage.getItem(aliasedKey)) {
            mixpanel.alias(distinctId, current);
            localStorage.setItem(aliasedKey, "1");
        }
        mixpanel.identify(distinctId);
        mixpanel.people.set({
            $email: email,
            ...(properties ?? {}),
        });
    }
    catch (e) {
        console.warn("[analytics] Mixpanel register failed", distinctId, e);
    }
}
/** Clears Mixpanel identity and super properties (e.g. after sign-out). SDK stays initialised. */
export function resetMixpanelBrowser() {
    if (typeof window === "undefined")
        return;
    if (!mixpanelInitialized)
        return;
    try {
        mixpanel.reset();
    }
    catch (e) {
        console.warn("[analytics] Mixpanel reset failed", e);
    }
}
